import { clearEnrollmentStore, type EnrollmentFormData } from '@/stores'
import { clearEnrollmentBrowserState } from '../../../state/enrollmentBrowserStorage'
import type { AddressParts, ApplicationFormData } from '../types'
import { getBlankApplicationFormData } from './storage'

type DraftAddressParts = {
  city: string
  state: string
  zipCode: string
}

export type UpdateEnrollmentDraft = (data: Partial<EnrollmentFormData>) => void

type PersistApplicationDraftArgs = {
  addressParts: DraftAddressParts
  formData: ApplicationFormData
  updateEnrollmentDraft: UpdateEnrollmentDraft
}

type PersistSelectedAddressArgs = {
  addressLine1: string
  addressParts: AddressParts
  updateEnrollmentDraft: UpdateEnrollmentDraft
}

export function persistApplicationDraft({
  addressParts,
  formData,
  updateEnrollmentDraft
}: PersistApplicationDraftArgs) {
  updateEnrollmentDraft({
    firstName: formData.firstName,
    lastName: formData.lastName,
    middleName: formData.middleName,
    email: formData.email,
    phone: formData.phoneNumber,
    phoneNumber: formData.phoneNumber,
    addressLine1: formData.addressLine1,
    city: addressParts.city,
    state: addressParts.state,
    zipCode: addressParts.zipCode,
    birthDate: formData.birthDate,
    about: formData.about,
    termsAccepted: formData.termsAccepted,
    marketingConsent: formData.termsAccepted,
    smsConsent: formData.termsAccepted
  })

  persistSelectedAddress({
    addressLine1: formData.addressLine1,
    addressParts,
    updateEnrollmentDraft
  })
}

export function persistSelectedAddress({
  addressLine1,
  addressParts,
  updateEnrollmentDraft
}: PersistSelectedAddressArgs) {
  updateEnrollmentDraft({
    addressLine1,
    city: addressParts.city ?? '',
    state: addressParts.state ?? '',
    zipCode: addressParts.zipCode ?? ''
  })
}

export function resetApplicationDraftForEmail(email: string) {
  clearEnrollmentStore()
  clearEnrollmentBrowserState()
  return getBlankApplicationFormData(email)
}
